<template>
  <div class="toolbar_cut toolbar-icon" :title="$t('title.cut')" @click="cut">
    <custom-icon :class-name="icons.Cut" />
  </div>
</template>
<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";
import { icons } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  data() {
    return {
      icons: icons,
    };
  },
  methods: {
    cut() {
      hotkeys.trigger("ctrl+x", HotkeyScopes.ProcessDesigner);
    },
    callFunc() {
      this.cut();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.toolbar_cut {
  padding: 0 0.3rem;
}
</style>
